import {getBaseUrl} from "../helpers";

export default {
     urlPrefix: getBaseUrl(),
     apiBasePath: getBaseUrl() + '/api',
}
